export const lightTheme = {
  background: 'rgb(240, 231, 219)',
  text: '#1A202C',
  navbarBackground: 'rgba(255, 255, 255, 0.25)',
  quoteBackground: 'rgba(255, 255, 255, 0.36)',
}

export const darkTheme = {
  background: 'rgb(32, 32, 35)',
  text: '#FAFAFA',
  navbarBackground: '#20202380',
  quoteBackground: 'rgba(255, 255, 255, 0.08)',
}
